/**
 * Compares firmware versions.
 * Supports both 2-part (e.g., "63.08") and 3-part (e.g., "2.5.12") formats.
 * Returns true if versionToCheck >= major.minor[.patch]
 * 
 * @param versionToCheck - The firmware version string to check
 * @param major - Required major version
 * @param minor - Required minor version
 * @param patch - Optional patch version (for 3-part versions like "2.5.12")
 */
export const isFirmwareGreaterThanOrEqualTo = (
  versionToCheck: string | number | undefined,
  major: number,
  minor: number,
  patch?: number
): boolean => {
  if (versionToCheck === undefined) {
    return false;
  }

  const parts = versionToCheck.toString().split(".");
  const fwMajor = Number(parts[0]);
  const fwMinor = Number(parts[1] ?? 0);

  if (fwMajor > major) return true;
  if (fwMajor < major) return false;
  if (fwMinor > minor) return true;
  if (fwMinor < minor) return false;

  // If patch is specified, compare it
  if (patch !== undefined) {
    const fwPatch = Number(parts[2] ?? 0);
    return fwPatch >= patch;
  }

  return true;
}